// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {alertService} from "../../../services/AlertService";
import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";
import {getOum, insertOum, OumSelector, updateOum} from "./oumSlice";

import {Colors} from "../../../assets/Colors";

const OumPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const Oum = useSelector(OumSelector);

    useEffect(() => {
        dispatch(
            getOum({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {

        if (search !== "" && Oum.isGetSuccess && !Oum.isGetFetching) {
            let calc = Oum?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = Oum.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && Oum.isGetSuccess && !Oum.isGetFetching) {
            let calc = Oum?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = Oum.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !Oum?.isGetFetching &&
            Oum.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = Oum?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = Oum.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getOum({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (Oum.isGetSuccess) {
                alertService.success(Oum.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getOum({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (Oum.isUpdateSuccess) {
                alertService.success(Oum.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateOum({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetOum(params) {
    //   return dispatch(getOum(params));
    // }

    function handleInsertOum(param) {
        setInsertFetch(true);
        const params = {
            NamaOum: param.inputOneValue,
            CategoryID: param.dropDownOumValue,
        };
        // 
        dispatch(insertOum(params));
    }

    function handleUpdateOum(param) {
        setUpdateFetch(true);

        const params = {
            NamaOum: param.inputOneValue,
            OumID: currentData.OumID,
            status: param.status,
            CategoryID: param.dropDownOumValue,

        };
        dispatch(updateOum(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getOum(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getOum(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = Oum.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? Oum.count : newCount,
            search: search,
        };
        dispatch(getOum(params));

        setPage(1);
        setCount(newCount === "-1" ? Oum.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Uom"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Uom"
                                tableData={Oum.data}
                                colOneTitle="ID"
                                colOneData="OumID"
                                colTwoTitle="Nama Uom"
                                colTwoData="NamaOum"
                                colThreeTitle="Kelompok Uom"
                                colThreeData="CategoryName"
                                status="Status"
                                fetching={Oum.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        dropDownOum={true}
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Uom"
                        inputOneTitle="Nama Uom"
                        inputOneValue=""
                        dropDownOumValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertOum}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        dropDownOum={true}
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.OumID}
                        modal={handleModal}
                        modalTitle="Ubah Oum"
                        inputOneTitle="Nama Oum"
                        inputOneValue={currentData.NamaOum}
                        dropDownOumValue={currentData.CategoryID}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateOum}
                    />
                )}
            </div>
        );
    }
};

export default OumPage;
